import React from 'react';
import { Check } from 'lucide-react';
interface ChecklistItemProps {
  children: React.ReactNode;
}
export function ChecklistItem({
  children
}: ChecklistItemProps) {
  return <li className="flex items-start gap-4 py-3" data-id="element-154">
      <div className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#E8E2DB] flex items-center justify-center text-[#C4856A]" data-id="element-155">
        <Check className="w-4 h-4" strokeWidth={3} data-id="element-156" />
      </div>
      <span className="text-lg text-[#4A4540] leading-relaxed" data-id="element-157">{children}</span>
    </li>;
}